import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import { useTheme } from "../utils/ThemeContext";

const About = () => {
  const { language, t } = useLanguage();
  const { theme } = useTheme();

  const cvUrl = language === "en" ? "/MWAFRIKA_CV_EN.pdf" : "/MWAFRIKA_CV_FR.pdf";

  return (
    <section
      className="flex flex-row h-[25rem] xxxs:h-auto xxxs:flex-col-reverse xxs:h-auto xxs:flex-col-reverse xs:h-auto xs:flex-col-reverse justify-between xxxs:mx-auto xxxs:pl-1 xxs:mx-auto xxs:pl-1 xs:mx-auto sm:mx-auto xs:pl-1 sm:justify-between sm:items-center"
      id="about"
    >
      <div className="sm:w-2/3 reveal reveal-left">
        <h2 className={`${theme === "dark" ? "title-dark" : "title"}`}>
          {t.titleAbout}
        </h2>
        <p className="text-white dark:text-slate-800 my-4 text-lg md:text-2xl lg:text-xl font-medium leading-snug">
          {language === "en"
            ? "Hello, I'm here to assist you"
            : "Bonjour, je suis là pour vous aider"}
          <br />
          <span className="text-gray-400 dark:text-slate-500 font-normal">
            {language === "en"
              ? "with your next project."
              : "pour votre prochain projet."}
          </span>
        </p>
        <p className="text-base pb-10 text-gray-400 max-w-2xl dark:text-slate-600 leading-relaxed">
          {t.infoAbout}
        </p>
        <div className="flex flex-wrap justify-start gap-3">
          <a
            href={cvUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-press inline-block bg-gradient-to-r from-violet-500 to-sky-500 text-white px-8 xxxs:text-base xxxs:px-5 xxs:text-base xxs:px-5 xs:text-base xs:px-5 sm:text-base py-2.5 rounded-xl font-semibold focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            {language === "en" ? "View CV" : "Voir le CV"}
          </a>
          <a
            href={cvUrl}
            download="mwafrika_josue.pdf"
            className="inline-flex items-center gap-2 text-base text-gray-400 dark:text-slate-600 underline underline-offset-4 decoration-gray-600 dark:decoration-slate-400 hover:text-violet-400 dark:hover:text-violet-600 hover:decoration-violet-400 dark:hover:decoration-violet-400 transition-all duration-200 py-2.5"
          >
            {language === "en" ? "Download CV" : "Mon CV"}
            {t.download}
          </a>
        </div>
      </div>

      <div className="flex items-center justify-center reveal reveal-right">
        <div className="relative">
          {/* Animated glow blur ring */}
          <div className="profile-glow-ring absolute -inset-1 rounded-full bg-gradient-to-tr from-violet-500 via-sky-400 to-violet-600 blur-[3px]" />
          {/* Solid gradient border */}
          <div className="relative rounded-full p-[4px] bg-gradient-to-tr from-violet-500 via-sky-400 to-violet-600">
            <img
              src={t.imageAbout}
              alt="Mwafrika Josué — Full Stack Web Developer"
              className="rounded-full w-64 h-64 xxxs:w-28 xxxs:h-28 xxs:w-28 xxs:h-28 xs:w-28 xs:h-28 sm:w-32 sm:h-32 md:w-44 md:h-44 object-cover ring-[3px] ring-slate-900 dark:ring-white transition-transform duration-500 hover:scale-[1.02]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
